















































import { Vue, Prop, Component } from "vue-property-decorator";
import { Condition as ICondition } from "@/api-v2/agent/models/condition";
import { getCurrentCompanyId } from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";

@Component({
  components: { CPageButtons, CustomButton }
})
export default class ConditionForm extends Vue {
  @Prop() condition?: ICondition;
  @Prop({ default: false }) isLoading?: boolean;

  conditionForm: ICondition = {
    companyId: this.condition?.companyId ?? this.companyId,
    title: this.condition?.title ?? "",
    description: this.condition?.description ?? "",
    percent: this.condition?.percent ?? false,
    value: this.condition?.value ?? 0,
    id: this.condition?.id ?? undefined
  };

  get companyId() {
    return getCurrentCompanyId();
  }

  onSubmit() {
    if (this.conditionForm?.title?.length) {
      this.$emit("save", this.conditionForm);
    } else {
      this.$bvToast.toast(
        `${this.$tc(this.$translate.SomeRequiredFieldsAreNotFilledIn)}`,
        {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        }
      );
    }
  }

  onCancel() {
    this.$emit("cancel");
  }

  onRemove() {
    this.$emit("delete", this.conditionForm?.id);
  }
}
